"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarHorizontal = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const ProgressBarHorizontal = () => {
    const [completedSteps, setCompletedSteps] = (0, react_2.useState)(1);
    const labels = [
        {
            text: 'step 1',
            onClick: () => {
                setCompletedSteps(1);
            },
        },
        {
            text: 'step 2',
            onClick: () => {
                setCompletedSteps(2);
            },
        },
        {
            text: 'step 3',
            onClick: () => {
                setCompletedSteps(3);
            },
        },
        {
            text: 'step 4',
            onClick: () => {
                setCompletedSteps(4);
            },
        },
    ];
    return (react_2.default.createElement(react_1.VStack, { alignItems: 'flex-start' },
        react_2.default.createElement(UiKitLite_1.UiKitLite.Progress.Horizontal, { labels: labels, showYellowLines: true, isFullWidth: false, numberOfBlobs: labels.length, numberOfBlobsCompleted: completedSteps }),
        react_2.default.createElement(react_1.HStack, null,
            react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Cancel, { isSmall: true, text: 'Back', onClick: () => setCompletedSteps(completedSteps - 1), disabled: completedSteps === 0 }),
            react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Primary, { isSmall: true, text: 'Next', onClick: () => setCompletedSteps(completedSteps + 1), disabled: completedSteps === labels.length }))));
};
exports.ProgressBarHorizontal = ProgressBarHorizontal;
